import graphql__352eb8da7a6a4a7ea255 from "./__generated__/ContributionsDatavizSearchFilters_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import { flatten } from "lodash";

import { useFormatMessage } from "../../../Intl/Context";
import ContributionsDatavizFilters from "./ContributionsDatavizFilters";
import ContributionsDatavizSearchFiltersThemes from "./ContributionsDatavizSearchFiltersThemes";
import { ContributionsDatavizSearchResults_participativeModule } from "./ContributionsDatavizSearchResults";

const ContributionsDatavizSearchFilters = props => {
  const participativeModule = useFragment(
    ContributionsDatavizSearchFilters_participativeModule,
    props.participativeModule
  );
  const { themes } = participativeModule;
  const subThemes = flatten(themes.map(({ children }) => children));
  const finalThemes = flatten(subThemes.map(({ children }) => children));

  const t = useFormatMessage();
  const labels = {
    theme: t(intlMessages.theme),
    topic: t(intlMessages.topic),
    question: t(intlMessages.question),
    tag: t(intlMessages.tag)
  };

  return (
    <ContributionsDatavizFilters
      participativeModule={participativeModule}
      refetchFragment={ContributionsDatavizSearchResults_participativeModule}
      refetchFragmentParent={participativeModule}
    >
      <div className="margin-bottom-xs border-bottom">
        <h3 className="d-block text-bolder margin-bottom-xs">{labels.theme}</h3>
        <ContributionsDatavizSearchFiltersThemes themes={themes} />
      </div>

      {subThemes.length > 0 && (
        <div className="margin-bottom-xs border-bottom">
          <h3 className="d-block text-bolder margin-bottom-xs">{labels.topic}</h3>
          <ContributionsDatavizSearchFiltersThemes
            themes={subThemes}
            className="topicList"
          />
        </div>
      )}

      {finalThemes.length > 0 && (
        <div className="margin-bottom-xs border-bottom">
          <h3 className="d-block text-bolder margin-bottom-xs">{labels.question}</h3>
          <ContributionsDatavizSearchFiltersThemes
            themes={finalThemes}
            className="questionList"
          />
        </div>
      )}
    </ContributionsDatavizFilters>
  );
};

const ContributionsDatavizSearchFilters_participativeModule = graphql__352eb8da7a6a4a7ea255;

export default ContributionsDatavizSearchFilters;

const intlMessages = defineMessages({
  theme: {
    id: "participativeModule.contributionsDataviz.filters.theme",
    defaultMessage: "Thème"
  },
  topic: {
    id: "participativeModule.contributionsDataviz.filters.topic",
    defaultMessage: "Sujet"
  },
  question: {
    id: "participativeModule.contributionsDataviz.filters.question",
    defaultMessage: "Question"
  },
  tag: {
    id: "participativeModule.contributionsDataviz.filters.tag",
    defaultMessage: "Rechercher par mot-clé"
  }
});
